<template>
	<div class="flex-end" style="width: 100%;">
		<div class="flex-grow flex-column" style="gap: 16px;"><slot></slot></div>
		<div v-if="!disabled" class="lock" :class="{'z-lock': lock}">
			<a class="flex-center" @click="lock = !lock"><i class="tf">&#xe670;</i></a>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			value: {
				type: Boolean,
				default: true
			},
			disabled: Boolean
		},

		data() {
			return {
				lock: this.value
			}
		},

		watch: {
			value(val) {
				this.lock = val;
			},

			lock: {
				handler(val) {
					this.$emit('input', val);
				},
				immediate: true
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.lock {
		position: relative;
		box-sizing: border-box;
		width: 18px;
		height: 54px;
		border: 1px dashed #ccc;
		border-left: none !important;
		margin-bottom: 19px;

		&.z-lock {
			border-style: solid;
			border-color: #999;
		}

		a {
			position: absolute;
			top: 50%;
			right: -11px;
			width: 20px;
			height: 28px;
			border-radius: 4px;
			margin-top: -14px;
			font-size: 16px;
			color: #666;
			background: #eee;

			^[-1].z-lock ^[-1..-1] {
				color: var(--color-main);
				background: #E9FFF4;
			}
		}
	}
</style>